import { MapPin } from "lucide-react";
import { toast } from "sonner";
import { MapCheck } from "@/components/boy/MapCheck";
import { EMPTY_ADDR } from "@/lib/boy";

const label = (a = {}) => [[a.street, a.number].filter(Boolean).join(", "), a.district, [a.city, a.state].filter(Boolean).join("/")].filter(Boolean).join(" - ");

export function StoreLocation({ code, bx, merchant, onSaved }) {
  const value = merchant.pin ? [merchant.pin.lat, merchant.pin.lng] : null;
  const save = async (p) => {
    await bx.put("/location", { lat: p[0], lng: p[1] });
    toast.success("Localização da loja salva");
    onSaved();
  };
  return (
    <section className="card-surface space-y-3 p-4" data-testid="boy-store-location">
      <div className="flex items-start gap-2">
        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <div className="min-w-0">
          <p className="font-semibold">Localização da loja</p>
          <p className="text-xs text-muted-foreground" data-testid="boy-store-location-address">{label(merchant.address)}</p>
        </div>
      </div>
      {!value && <p className="text-xs text-amber-600 dark:text-amber-400" data-testid="boy-store-location-missing">Marque no mapa onde fica a sua loja. O entregador recebe este ponto quando aceitar a corrida.</p>}
      <MapCheck code={code} addr={{ ...EMPTY_ADDR, ...merchant.address }} value={value} onSave={save} testid="boy-store-location" />
    </section>
  );
}
